// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__Zo9d7","row_titles":"Footer_row_titles__Dor-M","logo":"Footer_logo__7Vs+-","tinkoff":"Footer_tinkoff__FJ09Q"};